<template>
    <div class="app-main buy-check">
        <div class="top-bar">
          <el-input placeholder="输入商品名称搜索" v-model="title" @change="handleSearch()" clearable class="search-input">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>

          <el-button type="danger" plain @click="handleDel(ids)">多选删除</el-button>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table  :data="tableData" @selection-change="handleSelect" height="600"  style="width: 100%;">
                <el-table-column  type="selection"   width="80"          align="center"> </el-table-column>
                <el-table-column  label="商品图片" align="center" width="130">
                    <template slot-scope="scope">
                        <table-img :src="scope.row.pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column    align="center" prop="title" label="商品所属" width="240" show-overflow-tooltip></el-table-column>
                <el-table-column    align="center" prop="belongs_data" label="商品所属" width="160"></el-table-column>
                <el-table-column    align="center" label="规格属性" width="200" > 
                    <template slot-scope="scope" >
                        <div v-if="scope.row.specs">
                            <p class="m-bottom-1" v-for="(item, index) in scope.row.specs" :key="index">
                                <el-tag size="medium" >{{item.attr_symbol_string}}</el-tag>
                            </p>                       
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center"  label="添加到订货单">
                    <template slot-scope="scope" >
                        <p class="m-bottom-2"><el-button type="success" plain size="small" @click="handleOrder(scope.row)">添加到订货单</el-button></p>
                        <p><el-button type="danger"  plain size="small" @click="handleDel(scope.row.id)">删除采购商品</el-button></p>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper"  style="padding:15px 15px 15px 0" :page-size="size" :total="total" @current-change="loadMore"> </el-pagination>
        </el-card>
    </div>
</template>



<script>
import {  purchase_get, purchase_del, purchase_order } from '@/api/buy.js'
import tableImg from '@/components/Image.vue'
export default {
    components: { tableImg },
    data() {
        return {
            title:'',
            tableData:[],
            total:0,
            page:1,
            size:20,
            ids:'',      // 表格选中的id集合
        }
    },
    methods: {
      
        getData(){
            let params = {
                page:this.page,
                belongs: 1
            }
            if(this.title != ""){
                params.title_search = this.title
            }
            purchase_get(params).then(res => {
                console.log(res)
                if(res.code == 20000){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }else{
                     this.tableData = []
                }

            })
        },
        loadMore(page){
            this.page = page;
            this.getData()
        },
        // 搜索数据
        handleSearch(){
            this.page = 1;
            this.getData();
        },
        // 表格选中数据 
        handleSelect(rows){
            this.ids = '';
            rows.forEach(e => {
                this.ids += e.id + ','
            })
        },

        // 删除
        handleDel(id){
            purchase_del(id).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success', message:res.msg,duration:1500 })
                }
            })
        },

        // 添加到订货单
        handleOrder(it){
            let params = {
                purchase_id:it.id
            }
            purchase_order(params).then(res => {
                if(res){
                    this.title = ''
                    this.getData()
                    this.$message({type:'success', message:res.msg,duration:1500 })
                }
            })

        },
    },
    mounted(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>




